import { displayToast } from '../../components/Toaster/displayToast';
import generateHeaders from '../myHeaders';

const deleteUserColorSwatch = (
    id: number,
    successMessage: string,
    errorMessage: string,
    mutate: () => void,
    selectedSchema: string,
) => {
    const url = `${process.env.REACT_APP_API_URL}/user/color-swatches/${id}`;

    const requestOptions = {
        method: 'DELETE',
        headers: generateHeaders(selectedSchema),
    };

    return fetch(url, requestOptions)
        .then((response) => {
            if (!response.ok) {
                displayToast(errorMessage, 'error');

                return undefined;
            }
            displayToast(successMessage, 'success');
            mutate();

            return response.json();
        }).catch(() => {
            displayToast(errorMessage, 'error');
        });
};

export default deleteUserColorSwatch;
